import React, { Component } from "react";
import { Alert, FormGroup, Label, Input, Col, Row, Button, Popover, PopoverHeader, PopoverBody} from "reactstrap";
import ErrorMessage from '../../../../components/Message/ErrorMessage/ErrorMessage';
import * as url from '../../../../utils/url';
import {staticTitles} from '../../../../utils/constants'

import Checkbox from 'rc-checkbox';
import Tooltip from '../../../../components/UI/TooltipIcon/TooptipIcon';
import findIndex from 'lodash/findIndex';
import axios from '../../../../axios';
import 'rc-checkbox/assets/index.css';
import "../AddTool.css";

export default class Focus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      diversityFocusOptions: this.props.diversityFocusOptions,
      relevantForOptions: this.props.relevantForOptions,
      diversityFocus: this.props.toolDetails.diversityFocus|| this.props.diversityFocusOptions.filter(e=> e.focus==="All"),
      relevantFor: this.props.toolDetails.relevantFor || this.props.relevantForOptions.filter(e=>e.focus==="All"),
      diversityFocusTags: this.props.toolDetails.diversityFocusTags,
      relevantForTags: this.props.toolDetails.relevantForTags,
      diversityFocusPopoverOpen: false,
      aimedAtPopoverOpen: false,
      disabled: false
    };
    // console.log(this.props)


    // console.log(this.props.toolDetails.diversityFocus)
    // console.log(this.props.diversityFocusOptions)
    // console.log(this.props.toolDetails.relevantForTags)
    // console.log(this.props.relevantForOptions)
    // let v = this.props.diversityFocusOptions.filter(e=> console.log(e))
    // console.log(v)
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    // this.getToolFocusOptions();
  }
  
  // getToolFocusOptions = () => {
  //   axios.get(url.getAllFoucsList).then(response => {
  //       //  console.log(response);
  //        let diversityFocusOptions = [];
  //        let relevantForOptions = [];
  //        for(let filter of response.data) {
  //          if(filter._id === "1") {
  //            for(let option of filter.filterValues) {
  //             diversityFocusOptions.push({...option})
  //            }
  //           let diversityTagFoucs = {key: 'otherDiversityFocus', focus: 'Other', type: 'diversityFocusTag'}
  //           diversityFocusOptions = [...diversityFocusOptions, {...diversityTagFoucs}];
  //          } else if (filter._id === "2") {
  //             for(let option of filter.filterValues) {
  //               relevantForOptions.push({...option})
  //             }
  //             let relevantForTagFoucs = {key: 'otherRelevantFor', focus: 'Other', type: 'relevantForTag'};
  //             relevantForOptions = [...relevantForOptions, {...relevantForTagFoucs}];
  //          }
  //     }
  //   this.setState({diversityFocusOptions: diversityFocusOptions, 
  //     relevantForOptions: relevantForOptions         
  //   })
  //   }).catch(error => {
  //        console.log(error);
  //     });
  // }

  componentWillReceiveProps(nextProps) {
    let {diversityFocusOptions, relevantForOptions} = this.state;
    if(diversityFocusOptions.length === 0 || relevantForOptions.length===0) {
      this.setState({diversityFocusOptions: nextProps.diversityFocusOptions,
        relevantForOptions: nextProps.relevantForOptions});
    } 
  }

  checkUpdateField = (val) =>{
    // console.log('val---', val)
    if(this.props.tool_status=='Edit'){
      this.props.updateToolFields(val)
    }
  }

  handleDiversityFocusChange = (selectedFocus) => {
    const {diversityFocus} = this.state;
    const i = findIndex(diversityFocus, (option) => {return option.key === selectedFocus.key});
    if(i > -1) {
      diversityFocus.splice(i,1);
      if(selectedFocus.focus === 'Other') {
        this.setState({
          diversityFocus : diversityFocus,
          diversityFocusTags: ''
        });
      } else {
        this.setState({
          diversityFocus : diversityFocus
        });
      }
    } else {
      diversityFocus.push(selectedFocus);
      this.setState({
        diversityFocus : diversityFocus
      });
      // console.log(this.state.diversityFocus)
    }
    this.checkUpdateField('diversityFocus')
    
  }

  handleRelevantChange = (selectedFocus) => {
    const {relevantFor} = this.state;
    const i = findIndex(relevantFor, (tool) => {return tool.key === selectedFocus.key});
    if(i > -1) {
      relevantFor.splice(i,1);
      if(selectedFocus.focus === 'Other') {
        this.setState({
          relevantFor : relevantFor,
          relevantForTags: ''
        });
      } else {
        this.setState({
          relevantFor : relevantFor
        });
      }
    } else {
      relevantFor.push(selectedFocus);
      this.setState({
        relevantFor : relevantFor
      });
    }
    this.checkUpdateField('relevantFor')
    
  }

  handleDiversityFocusTagsChanged = ({target}) => {
    this.setState({diversityFocusTags: target.value});
    this.checkUpdateField('diversityFocusTags')
  }

  handleRelevantForTagsChanged = ({target}) => {
    this.setState({relevantForTags: target.value});
    this.checkUpdateField('relevantForTags')
  }


  validateToolInfo = () => {
    let {diversityFocus, relevantFor, diversityFocusTags, relevantForTags} = {...this.state};
    if(diversityFocus.length === 0 ) {
       this.setState({error: true, errorMessage: `Please select at least one option for the type(s) of "Diversity" this ${staticTitles.toolkit_sm} is focused on.`});
    } else if(relevantFor.length === 0) {
      this.setState({error: true, errorMessage: `Please select at least one option for the organizational role(s) this ${staticTitles.toolkit_sm} is "Aimed at".`});
    } else {
       let otherDiversityFocus = diversityFocus.filter((selectedFocus) => selectedFocus.focus === 'Other');
       let otherAimedAt = relevantFor.filter((selectedFocus) => selectedFocus.focus === 'Other');
       if(otherDiversityFocus.length>0 && diversityFocusTags.trim() === "") {
        this.setState({error: true, errorMessage: 'Please enter tags in diversity focus other option'});
        return; 
       }
       if(otherAimedAt.length>0 && relevantForTags.trim() === "") {
        this.setState({error: true, errorMessage: 'Please enter tags in aimed at other option'});
        return; 
       }
       let currentState = {...this.state};
       delete currentState.diversityFocusOptions;
       delete currentState.relevantForOptions;
       this.props.onCompleted({...currentState});
     }
  }

  // Toggle popover
  toggleDiversityFocus = () => {
    this.setState({
      diversityFocusPopoverOpen: !this.state.diversityFocusPopoverOpen,
      aimedAtPopoverOpen: false
    });
  }

  toggleAimedAt = () => {
    this.setState({
      aimedAtPopoverOpen: !this.state.aimedAtPopoverOpen,
      diversityFocusPopoverOpen: false
    });
  }

  // Go to previous step
  goToPreviousStep = () => {
    this.props.goBackToPreviousStep();
  }

  render() {
    let {diversityFocusOptions, relevantForOptions, diversityFocus, relevantFor} = {...this.state};
    let diversityFocusCheckOptions = null;
    let relevantFousCheckOptions = null;
    let alert = null;
    // console.log(diversityFocus)
    let diversityFocusOtherTagsInput = <div className="col-sm-9 col-md-9 pr0"><Input className="input-custom other-input-filed other-input-text" value={this.state.diversityFocusTags} onChange={this.handleDiversityFocusTagsChanged} type="text"/></div>;
    let relevantForOtherTagsInput = <div className="col-sm-9 col-md-9 pr0"><Input className="input-custom other-input-filed other-input-text" value={this.state.relevantForTags} onChange={this.handleRelevantForTagsChanged} type="text"/></div>;
    if(this.state.error) {
      alert = <ErrorMessage message={this.state.errorMessage}/>
    };
    if(diversityFocusOptions.length>0) {
      diversityFocusCheckOptions = (diversityFocusOptions.map((option, index) => {
        return (
          <span key={index} className={option.focus == "Other" ? "col-sm-6 display-inline mt10" : "col-sm-4 col-md-4 " }>
            <Label>
              <Checkbox
                defaultChecked = {findIndex(diversityFocus, 
                       (selectedFocus) => {return option.key === selectedFocus.key}) > -1}
                onClick={() => this.handleDiversityFocusChange(option)}
                disabled={this.state.disabled}
              />
              <span className="ml10 focus-check-option">{option.focus}{option.focus == "Other" ? ':': ''}</span>
            </Label>
             {(option.focus == "Other" && findIndex(diversityFocus, 
                       (selectedFocus) => {return option.key === selectedFocus.key}) > -1) ? diversityFocusOtherTagsInput : null}
          </span>
      )
      }))}

    if(relevantForOptions.length>0) {
      relevantFousCheckOptions = (relevantForOptions.map((option, index) => {
          return (
            <span key={index} className={option.focus == "Other" ? "col-sm-6 display-inline " : "col-sm-3 col-md-3 " }>
             <Label style={{display: 'inline-flex'}}>
              <Checkbox
               defaultChecked = {findIndex(relevantFor, 
                     (selectedFocus) => {return option.key === selectedFocus.key}) > -1}
               onClick={() => this.handleRelevantChange(option)}
               disabled={this.state.disabled}
             />
            <span className="ml10 focus-check-option">{option.focus}{option.focus == "Other" ? ':': ''}</span>
          </Label>
          {(option.focus == "Other" && findIndex(relevantFor, 
                     (selectedFocus) => {return option.key === selectedFocus.key}) > -1) ? relevantForOtherTagsInput : null}
         </span>
        )
        }))}



    return (
      <form>
        {alert}
        <FormGroup className="mb0" row>
          <Col sm={3} className="text-right">
          <div className="row d-flex justify-content-end mlmr0"> 
            <span id="diversity-focus-popover" style={{marginRight: '10px'}} onClick={this.toggleDiversityFocus}><Tooltip/></span>
            <span className="addToolLabel">Diversity Focus</span>
           <Popover placement="left" isOpen={this.state.diversityFocusPopoverOpen} target="diversity-focus-popover" toggle={this.toggleDiversityFocus}>
            <PopoverHeader className="popover-header-tooltip">Diversity Focus</PopoverHeader>
            <PopoverBody className="popover-body-tooltip">Select the diversity group that best describes the focus of this resource. You can also select “Other” and type in up to 3 diversity groups, separated by commas, that better describe the focus of this resource.</PopoverBody>
           </Popover>
          </div>
            <div className="focus-instruction d-flex justify-content-end">(Select all that apply)</div>   
          </Col>
          <Col sm={9} className="text-left align-self-center focus-check-section">
              {diversityFocusCheckOptions}
          </Col>
        </FormGroup>
        <FormGroup className="mt40 mb0" row>
        <Col sm={3} className="text-right">
           <div className="row d-flex justify-content-end mlmr0"> 
            <span id="aimed-at-popover" style={{marginRight: '10px'}} onClick={this.toggleAimedAt}><Tooltip/></span>
            <span className="addToolLabel">Aimed at</span>
            <Popover placement="left" isOpen={this.state.aimedAtPopoverOpen} target="aimed-at-popover" toggle={this.toggleAimedAt}>
             <PopoverHeader className="popover-header-tooltip">Aimed at</PopoverHeader>
             <PopoverBody className="popover-body-tooltip">Select who primarily benefits from this resource. You can also select “Other” and type in up to 3 types of people, separated by commas, to better describe who this resource is intended for.</PopoverBody>
           </Popover>
          </div>
            <div className="focus-instruction d-flex justify-content-end">(Select all that apply)</div>   
          </Col>
          <Col sm={9} className="text-left align-self-center focus-check-section">
              {relevantFousCheckOptions}
          </Col>
        </FormGroup>
        <FormGroup className="mt40">
          <Row>
            <Col sm={{size: 3}}>
            <Button
                className="float-left goBackBtn ml10 w100"
                onClick={this.goToPreviousStep}
              >
            <span className="goBackBtnTxt">
            <span className="mr10 flaticon-back"></span> Go Back</span>
            </Button>
            </Col>
            <Col sm={{size: 3, offset: 6}}>
            <Button
                className="float-right continueBtn ml10 w100"
                onClick={this.validateToolInfo}
            >
            <span className="continueBtnTxt">Continue <span className="ml10 flaticon-next"></span> </span>
            </Button>
            </Col>
          </Row>
        </FormGroup>
      </form>
    );
  }
}
